import NoContent from "../NoContent/NoContent";
import Text from "../Text/Text";
import Image from "../Image/Image";
import FormPhone from "../FormPhone/FormPhone";
import FormOption from "../FormOption/FormOption";
import FormMultiOption from "../FormMultiOption/FormMultiOption";
import FormDropdown from "../FormDropdown/FormDropdown";
import FormTextarea from "../FormTextarea/FormTextarea";
import FormSubmitButton from "../FormSubmitButton/FormSubmitButton";
import FormRadioGrid from "../FormRadioGrid/FormRadioGrid";
import FormRating from "../FormRating/FormRating";
import FormCommonField from "../FormCommonField/FormCommonField";
import FormTerms from "../FormTerms/FormTerms";
import Divider from "../Divider/Divider";
import Coupon from "../Coupon/Coupon";
import WechatContentBlock from "../WechatContent/WechatContent";
import WechatQRCode from "../WechatQRCode/WechatQRCode";
import WechatHeader from "../WechatHeader/WechatHeader";
import WechatTextImage from "../WechatTextImage/WechatTextImage";
import WechatFollow from "../WechatFollow/WechatFollow";
import WechatTrackableQRCode from "../WechatTrackableQRCode/WechatTrackableQRCode";
import WechatSubscribeMessage from '../WechatSubscribeMessage/WechatSubscribeMessage';
import WechatLink from "../WeChatLink/WechatLink";
import HtmlBlock from "../Html/HtmlBlock";
import Button from "../Button/Button";
import Map from "../Map/Map";
import Heading from "../Heading/Heading";
import Countdown from "../Countdown/Countdown";
import FormThankyou from "../FormThankyou/FormThankyou";


// content show in editor panel
const ContentType = {
  heading: Heading,
  text: Text,
  image: Image,
  divider: Divider,
  html: HtmlBlock,
  button: Button,
  countdown: Countdown,
  coupon: Coupon,
  map: Map,
  "form-text": FormCommonField,
  "form-email": FormCommonField,
  "form-date": FormCommonField,
  "form-number": FormCommonField,
  "form-url": FormCommonField,
  "form-terms": FormTerms,
  "form-textarea": FormTextarea,
  "form-phone": FormPhone,
  "form-option": FormOption,
  "form-radio-grid": FormRadioGrid,
  "form-multi-option": FormMultiOption,
  "form-dropdown": FormDropdown,
  "form-submit-button": FormSubmitButton,
  "form-rating": FormRating,
  "form-thankyou": FormThankyou,
  "no-content": NoContent,
  "wechat-content": WechatContentBlock,
  "wechat-content-image": WechatTextImage,
  "wechat-follow": WechatFollow,
  "wechat-header": WechatHeader,
  "wechat-link": WechatLink,
  "wechat-qrcode": WechatQRCode,
  "wechat-subscribe-message": WechatSubscribeMessage,
  "wechat-trackable-qrcode": WechatTrackableQRCode,
};

export default ContentType
